var _excluded = ["element", "iconLeft", "iconRight", "isActive", "isDisabled", "children", "className"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { string, node, bool, func, oneOfType, object, element } from 'prop-types';
import classNames from 'classnames';
import TextLink from '../../TextLink';
var propTypes = {
  /** The type of element you need. `a`, `Link` or `button` (from react router) are the most common.
   *
   * Example usage with React Router:<br>
   * `<DropdownItem element={Link} to="/somepage">Text</DropdownItem>` */
  element: oneOfType([string, func, object]),

  /** Children  */
  children: node.isRequired,

  /** Place icon before text. */
  iconLeft: element,

  /** Place icon after text. */
  iconRight: element,

  /** Highlight the menu item as active */
  isActive: bool,

  /** Disable the menu item, making it unselectable. */
  isDisabled: bool,

  /** Add your own custom class names to the component */
  className: string
};
var defaultProps = {
  isDisabled: false
};
/** A single item within a Dropdown Menu.
 * @visibleName Dropdown Item
 * */

var DropdownItem = function DropdownItem(_ref) {
  var element = _ref.element,
      iconLeft = _ref.iconLeft,
      iconRight = _ref.iconRight,
      isActive = _ref.isActive,
      isDisabled = _ref.isDisabled,
      children = _ref.children,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  var componentClassNames = classNames('rds-dropdown__item', {
    'rds-is-active': isActive,
    'rds-is-disabled': isDisabled
  }, className);
  return isDisabled ? /*#__PURE__*/React.createElement("span", {
    className: componentClassNames
  }, children) : /*#__PURE__*/React.createElement(TextLink, _extends({
    element: element,
    className: componentClassNames,
    iconLeft: iconLeft,
    iconRight: iconRight,
    hideUnderline: true,
    role: "option"
  }, rest), children);
};

DropdownItem.propTypes = propTypes;
DropdownItem.defaultProps = defaultProps;
export default DropdownItem;